import defaultComponents from 'gatsby-theme-carbon/src/components/MDXProvider/defaultComponents';

import ComponentCode from '../../../components/ComponentCode';
import ComponentReact from '../../../components/ComponentReact';
import MdxIcon from '../../../components/MdxIcon';
import ComponentDemo from '../../../components/ComponentDemo';

export default {
  ...defaultComponents,
  ComponentCode,
  ComponentReact,
  ComponentDemo,
  MdxIcon,
};
